import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../shared/services/local-storage.service';
import { getDefaultLandingPageByRole } from '@orderna/admin-panel/src/utils/get-default-landing-page';
import { ButtonComponent, ButtonTextDirective } from '../../../shared/components/button/button.component';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, ButtonComponent, ButtonTextDirective],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css',
})
export class NotFoundComponent {
  private readonly router = inject(Router);
  private readonly localStorage = inject(LocalStorageService);

  async onBackButtonClicked() {
    const accessToken = this.localStorage.getAccessToken();

    if (!accessToken) {
      await this.router.navigateByUrl('/login');
      return;
    }

    const role = this.localStorage.getRole()!;
    const defaultLandingPage = getDefaultLandingPageByRole(role);
    await this.router.navigateByUrl(defaultLandingPage);
  }
}
